// src/features/clients/hooks/useClients.js
import { useState, useCallback } from "react";
import { db } from "services/firebaseConfig";
import {
  collection,
  query,
  getDocs,
  doc,
  setDoc,
  deleteDoc,
  Timestamp,
  orderBy,
} from "firebase/firestore";
import toast from "react-hot-toast";

export const useClients = () => {
  const [clients, setClients] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Busca todos os clientes
  const fetchClients = useCallback(async () => {
    setIsLoading(true);
    try {
      const q = query(collection(db, "clients"), orderBy("name"));
      const querySnapshot = await getDocs(q);
      const fetchedClients = [];
      querySnapshot.forEach((doc) => {
        fetchedClients.push({ id: doc.id, ...doc.data() });
      });
      setClients(fetchedClients);
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
      toast.error("Erro ao carregar clientes.");
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Adiciona ou Atualiza um cliente
  const addClient = async (data) => {
    try {
      // Limpa o telefone para usar como ID
      const cleanPhone = data.phone.replace(/\D/g, "");

      if (!cleanPhone) {
        throw new Error("Telefone inválido para cadastro.");
      }

      const docId = cleanPhone; // ID do documento será o telefone
      const docRef = doc(db, "clients", docId);

      const clientData = {
        name: data.name,
        phone: data.phone,
        // ✅ 1. Adiciona o campo CPF (opcional, salva string vazia se não vier)
        cpf: data.cpf || "",
        city: data.city || "",
        createdAt: data.createdAt || Timestamp.now(),
        lastUpdate: Timestamp.now(),
        source: data.source || "manual",
      };

      await setDoc(docRef, clientData, { merge: true });
      return true;
    } catch (error) {
      console.error("Erro ao salvar cliente:", error);
      toast.error(`Erro ao salvar cliente: ${error.message}`);
      return false;
    }
  };

  const deleteClient = async (clientId) => {
    if (window.confirm("Tem certeza que deseja excluir este cliente?")) {
      try {
        await deleteDoc(doc(db, "clients", clientId));
        toast.success("Cliente excluído.");
        fetchClients();
      } catch (error) {
        toast.error("Erro ao excluir cliente.");
      }
    }
  };

  return {
    clients,
    isLoading,
    fetchClients,
    addClient,
    deleteClient,
  };
};
